<template>
  <v-card class="mb-3" outlined>
    <v-card-text class="py-2 px-3">
      <v-row align="center" dense>
        <v-col cols="auto">
          <v-icon small class="mr-1">mdi-calendar-check</v-icon>
          <span class="text-body-2 font-weight-medium">Contrôles périodiques</span>
        </v-col>
        
        <v-col v-if="!isLoading && periodicCheckStatus.length > 0">
          <v-chip
            x-small
            :color="overdueCount > 0 ? 'error' : 'success'"
            text-color="white"
            class="mr-1"
          >
            <v-icon x-small left>{{ overdueCount > 0 ? 'mdi-alert-circle' : 'mdi-check-circle' }}</v-icon>
            {{ overdueCount > 0 ? `${overdueCount} en retard` : 'À jour' }}
          </v-chip>
          <span class="text-caption grey--text">
            ({{ periodicCheckStatus.length }} contrôles)
            <span v-if="nextCheckDate">
              • Prochain: {{ formatDate(nextCheckDate) }}
            </span>
          </span>
        </v-col>
        
        <v-col v-if="!isLoading && periodicCheckStatus.length === 0">
          <span class="text-caption grey--text">Aucun contrôle configuré</span>
        </v-col>
        
        <v-col v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="primary"
            size="16"
            width="2"
          ></v-progress-circular>
        </v-col>
        
        <v-spacer></v-spacer>
        
        <v-col cols="auto">
          <v-btn
            x-small
            text
            color="primary"
            @click="goToPeriodicChecks"
          >
            Voir détails
            <v-icon x-small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PeriodicChecksStatus',
  props: {
    liftId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.periodicChecksStore.isLoading
    },
    periodicCheckStatus() {
      return this.$store.state.periodicChecksStore.periodicCheckStatus || []
    },
    overdueCount() {
      return this.periodicCheckStatus.filter(c => c.is_overdue).length
    },
    nextCheckDate() {
      // Find the closest next check date among all checks
      const datesWithNext = this.periodicCheckStatus
        .filter(c => c.next_check_date)
        .map(c => new Date(c.next_check_date))
        .sort((a, b) => a - b)
      
      return datesWithNext.length > 0 ? datesWithNext[0] : null
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('fr-FR', { 
        day: '2-digit', 
        month: '2-digit',
        year: 'numeric'
      })
    },
    goToPeriodicChecks() {
      this.$router.push({ 
        name: 'PeriodicChecks',
        query: { lift_id: this.liftId }
      })
    },
  },
  watch: {
    liftId: {
      immediate: true,
      handler(newLiftId) {
        if (newLiftId) {
          this.$store.dispatch('getPeriodicCheckStatus', newLiftId)
        }
      },
    },
  },
}
</script>

<style scoped>
</style>
